import { calculateDrammenSykehusRoomNumbers, } from "./drammenSykehusRoomNumbering";
import { calculateNrhRoomNumbers, } from "./nrhRoomNumbering";
export const calculateRoomNumbersForMethod = (methodKey, input) => {
    switch (methodKey) {
        case "DRAMMEN_SYKEHUS":
            return calculateDrammenSykehusRoomNumbers(input);
        case "NRH":
            return calculateNrhRoomNumbers(input);
        default: {
            const exhaustive = methodKey;
            throw new Error(`Unsupported room numbering method: ${exhaustive}`);
        }
    }
};
